import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    pin: {
        id: 'modal.settings.general.pin',
        defaultMessage: 'Change PIN',
    },
    block: {
        id: 'modal.settings.general.block',
        defaultMessage: 'Block Card',
    },
    threeDs: {
        id: 'modal.settings.general.three_ds',
        defaultMessage: '3DS settings',
    },
    topUpFee: {
        id: 'modal.settings.general.top_up',
        defaultMessage: 'Top up fee',
    },
    trFee: {
        id: 'modal.settings.general.tr_fee',
        defaultMessage: 'Transaction fee',
    },
    monthFee: {
        id: 'modal.settings.general.monthly_fee',
        defaultMessage: 'Monthly fee',
    },
    min: {
        id: 'modal.settings.general.min',
        defaultMessage: 'min',
    },
    max: {
        id: 'modal.settings.general.max',
        defaultMessage: 'max',
    },
})
